var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_38845",
    x: 26.621,
    y: 24.627,
    width: 18.127,
    height: 18.127,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New_site",
    "data-name": "New site",
    transform: "translate(-1043.518 -1618.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38841",
    "data-name": "Path 38841",
    d: "M26,0A26,26,0,1,1,0,26,26,26,0,0,1,26,0",
    transform: "translate(1043.518 1618.073)",
    fill: "#56aa1c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1043.52, 1618.07)",
    filter: "url(#Path_38845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38845-2",
    "data-name": "Path 38845",
    d: "M27.957,26.339H21.812V23.5h6.145V17.358h2.837V23.5h6.145v2.836H30.794v6.145H27.957Z",
    transform: "translate(6.31 7.77)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31725",
    "data-name": "Rectangle 31725",
    width: 12.369,
    height: 1.863,
    transform: "translate(1068.113 1637.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38846",
    "data-name": "Path 38846",
    d: "M21.137,22.793h1.924V21.446h4.221v-4.8H31.89v-1.52H19.519V28.494h1.618Z",
    transform: "translate(1048.593 1624.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38847",
    "data-name": "Path 38847",
    d: "M9.22,32.541H24.4V7.441H9.22ZM18,11.014H21.4v3.392H18Zm0,5.836H21.4v3.4H18ZM18,22.7H21.4v3.392H18ZM12.143,11.014h3.392v3.392H12.143Zm0,5.836h3.392v3.4H12.143Zm0,5.845h3.392v3.392H12.143Z",
    transform: "translate(1043.049 1620.506)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsite);
export default __webpack_public_path__ + "static/media/New site.8b85b341a1d5875084e25784ea8ac50f.svg";
export { ForwardRef as ReactComponent };